<template>
    <v-container class="container__principal flex-row-start no-pd" style="min-width: 100%">
        <v-col xs="12" sm="12" md="6" lg="6" xl="6" class="flex-col-center no-pd">

            <v-row v-if="signupByPontuation">
                <v-col xs="12" sm="12" md="12" lg="12" class="flex-col-center title-center">
                    <h1 class="h1--small text-center"> 
                        Parabéns! Você ganhou  
                        <span v-if="userLastPoints"> {{ userLastPoints }} </span> 
                        <span v-if="!userLastPoints"> alguns </span> 
                        pontos na sua compra! 
                    </h1>
                    <h4 class="h4--small text-center"> Confirme seus pontos preenchendo os dados abaixo e confira os benefícios que separamos para você. </h4>
                </v-col>
            </v-row>

            <div class="margin-top-divider-30" />        

            <v-row class="flex-col-center" v-if="showFacebookbtn">
                <v-btn text @click="facebookLogin()">
                    <v-icon large color="var(--cor--facebook)"> mdi-facebook </v-icon>
                    <span class="text-none btn__text-icon facebook-text"> Cadastrar com Facebook </span>
                </v-btn>
            </v-row>


            <v-row class="flex-col-center" v-if="showFacebookbtn">
                <v-col class="container-login__col_or">
                    <div class="lines" />

                    <div class="or"> OU </div>

                    <div class="lines" />
                </v-col>
            </v-row>

            
            <v-row class="flex-col-center" v-if="missingInformation">
                <h3 style="text-align: center"> Não identificamos todas as informações, favor preencher os campos abaixo. </h3>
            </v-row>

            <v-row class="flex-col-center" v-if="missingPassword && !missingInformation">
                <h3 style="text-align: center"> Ótimo, agora só falta escolher uma senha. </h3>
            </v-row>

            <div class="margin-top-divider-30" v-if="missingInformation || missingPassword" />

            <v-form v-model="validationTop" class="validation-form">
                <v-row class="flex-col-center">
                    <v-col xs="12" sm="12" md="12" lg="12" class="no-pd-b flex-col-center conditional-pd">
                        <v-text-field
                            class="w-100"
                            prepend-inner-icon="mdi-account-outline"
                            color="var(--cor--preta)"
                            placeholder="Nome completo"
                            clearable
                            solo
                            required
                            :disabled="!!signupUser.name"
                            v-model="newContactObject.name"
                            :error-messages="completeNameErrors"
                            @change="$v.newContactObject.name.$touch(), setUpperCaseName()"
                            @blur="$v.newContactObject.name.$touch()"
                        />

                        <v-text-field
                            class="w-100"
                            prepend-inner-icon="mdi-email-outline"
                            color="var(--cor--preta)"
                            placeholder="E-mail"
                            clearable
                            solo
                            required
                            :disabled="!!signupUser.email"
                            v-model="newContactObject.email"
                            @change="$v.newContactObject.email.$touch()"
                            @blur="$v.newContactObject.email.$touch()"
                            :error-messages="emailErrors"
                        />

                         <v-select
                            class="w-100"
                            prepend-inner-icon="mdi-state"
                            color="var(--cor--preta)"
                            placeholder="estado"
                            clearable
                            solo
                            required
                            v-model="estado"
                            :items="estados"
                            item-value="id"
                            item-text="name"
                        />

                            <v-autocomplete
                                  append-icon=""
                                    class="w-100"
                                    prepend-inner-icon="mdi-city"
                                    color="var(--cor--preta)"
                                    clearable                                    
                                    solo
                                    label="Cidade"
                                    placeholder="Escolha a cidade"
                                    :items="cidades"
                                    item-value="id"
                                    item-text="name"
                                    v-model="newContactObject.cidade"
                                    :search-input.sync="search"
                                    @change="$v.newContactObject.cidade.$touch()"
                                    @blur="$v.newContactObject.cidade.$touch()"
                                    :error-messages="cidadeErrors"
                                    >
                                    
                        </v-autocomplete>

                        <v-text-field
                            class="w-100"
                            prepend-inner-icon="mdi-lock-outline"
                            color="var(--cor--preta)"
                            placeholder="Senha"
                            solo
                            required
                            v-model="newContactObject.password"
                            :type=" ShowPassword? 'text' : 'password'"
                            :append-icon="ShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="ShowPassword = !ShowPassword"
                            @change="$v.newContactObject.password.$touch()"
                            @blur="$v.newContactObject.password.$touch()"
                            :error-messages="passwordErrors"
                        />

                        <v-text-field
                            class="w-100"
                            prepend-inner-icon="mdi-calendar-blank"
                            solo
                            required
                            color="var(--cor--preta)"
                            placeholder="Data de Nascimento"
                            type="text"
                            v-mask="'##/##/####'"
                            :disabled="!!signupUser.birthday"
                            v-model="newContactObject.birthday"
                            clearable
                            @change="$v.newContactObject.birthday.$touch()"
                            @blur="$v.newContactObject.birthday.$touch()"
                            :error-messages="birthdayErrors"
                        />

                        <v-select
                            class="w-100"
                            prepend-inner-icon="mdi-gender-male-female"
                            solo
                            required
                            :items="genders"
                            item-text="name"
                            item-value="value"
                            color="var(--cor--preta)"
                            placeholder="Gênero"
                            :disabled="!!signupUser.genderId"
                            v-model="newContactObject.genderId"
                            clearable
                            @change="$v.newContactObject.genderId.$touch()"
                            @blur="$v.newContactObject.genderId.$touch()"
                            :error-messages="genderIdErrors"
                        />

                        <v-text-field
                            class="w-100"
                            prepend-inner-icon="mdi-clipboard-outline"
                            solo
                            required
                            color="var(--cor--preta)"
                            placeholder="CPF"
                            type="text"
                            v-mask="'###.###.###-##'"
                            :disabled="!!signupUser.cpf"
                            v-model="newContactObject.cpf"
                            clearable
                            @change="$v.newContactObject.cpf.$touch()"
                            @blur="$v.newContactObject.cpf.$touch()"
                            :error-messages="cpfErrors"
                        />
                        
                        <v-text-field
                            class="w-100"
                            prepend-inner-icon="mdi-phone"
                            solo
                            required
                            color="var(--cor--preta)"
                            placeholder="Telefone"
                            v-mask="['(##) # ####-####','(##) ####-####']"
                            :disabled="!!signupUser.telephone"
                            v-model="newContactObject.telephone"
                            clearable
                            @change="$v.newContactObject.telephone.$touch()"
                            @blur="$v.newContactObject.telephone.$touch()"
                            :error-messages="telephoneErrors"
                        />

                        <v-btn class="w-100" :color="currentCompany.buttonsColor" :loading="createBtnLoading" :disabled="!validationTop" @click="submit()">
                            <span class="text-white text-none"> Criar minha conta </span>
                        </v-btn>
                        <div class="flex-row-center btn-subtitle">
                            <span class="text-center">
                                Ao cadastrar você concorda com nossos
                                <v-btn color="var(--cor--azul)" text class="custom-btn no-pd no-mg text-none" @click="openTermsModal()">
                                    termos de uso
                                </v-btn>
                            </span>
                        </div>

                    </v-col>
                </v-row>
            </v-form>


            
        </v-col>
        <v-col v-if="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" class="no-pd"  md="6" lg="6" xl="6">
            <div style="height: 100vh !important;" :style="{'background-color': currentCompany.primaryColor}" class=" flex-row-center">
                <div class="company-image--div">
                    <v-img width="100%" height="100%" class="company-image" :src="currentCompany.image"></v-img>
                </div>
                <div class="text-white company-name">{{currentCompany.name.toUpperCase()}}</div>
            </div>
        </v-col>

        <div v-if="termsDialog">
            <TermsModal :dialog="termsDialog" @closeTermsModal="termsDialog = $event" />
        </div>
    </v-container>
</template>

<script>
//Components
import TermsModal from "@/app/modals/terms-and-conditions-modal/terms-and-conditions-modal";

//Store
import { mapGetters, mapActions } from 'vuex'

//Plugins
import { email, minLength, required } from 'vuelidate/lib/validators'

//Functions
import { completeNameRule, telephoneRule} from "@/support/functions/validation.function";
import { upperCaseCompleteName } from "@/support/functions/name.functions";

//Services
import { insertContactByCompanyId, getPendingReviewsByCurrentContactIdAndCompanyId,
 getLastPointByCompanyIdAndContactTelephone, buscarCidadeIntegracao , buscarEstado } from "./service/signup.service";
import { authenticate } from "@/domain/auth/auth.service";

export default {
    name: 'SignUp',
    components: { TermsModal },
    computed: {
        ...mapGetters('signupStore', {
                signupUser: 'get_signup_user',
                haveAccessToSignup: 'get_access_signup'
            }
        ),
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        ),
        completeNameErrors () {
            const errors = []
            if (!this.$v.newContactObject.name.$dirty) return errors
            !this.$v.newContactObject.name.required && errors.push('Nome completo é obrigatório.')
            !this.$v.newContactObject.name.completeNameRule && errors.push('É preciso informar o nome completo.')
            return errors
        },
        emailErrors () {
            const errors = []
            if (!this.$v.newContactObject.email.$dirty) return errors
            !this.$v.newContactObject.email.required && errors.push('E-mail é obrigatório.')
            !this.$v.newContactObject.email.email && errors.push('E-mail inválido.')
            return errors
        },
        passwordErrors () {
            const errors = []
            if (!this.$v.newContactObject.password.$dirty) return errors
            !this.$v.newContactObject.password.required && errors.push('Senha é obrigatório.')
            !this.$v.newContactObject.password.minLength && errors.push('A senha deve ter no mínimo 8 dígitos.')
            return errors
        },
        birthdayErrors () {
            const errors = []
            if (!this.$v.newContactObject.birthday.$dirty) return errors
            !this.$v.newContactObject.birthday.required && errors.push('Data de nascimento é obrigatória.')
            !this.$v.newContactObject.birthday.minLength && errors.push('Data inválida.')
            return errors
        },
        genderIdErrors () {
            const errors = []
            if (!this.$v.newContactObject.genderId.$dirty) return errors
            !this.$v.newContactObject.genderId.required && errors.push('É obrigatório preencher o gênero.')
            return errors
        },
        cidadeErrors () {
            const errors = []
            if (!this.$v.newContactObject.cidade.$dirty) return errors
            !this.$v.newContactObject.cidade.required && errors.push('É obrigatório preencher o cidade.')
            return errors
        },
        cpfErrors(){
            const errors = []
            if (!this.$v.newContactObject.cpf.$dirty) return errors
            !this.$v.newContactObject.cpf.required && errors.push('CPF é obrigatório.')
            !this.$v.newContactObject.cpf.minLength && errors.push('CPF inválida.')
            return errors
        },
        telephoneErrors () {
            const errors = []
            if (!this.$v.newContactObject.telephone.$dirty) return errors
            !this.$v.newContactObject.telephone.required && errors.push('Telefone é obrigatório.')
            !this.$v.newContactObject.telephone.telephoneRule && errors.push('Telefone inválido.')
            return errors
        },
    },
    validations: {
      newContactObject: {
          name: { completeNameRule, required },
          cidade: { required },
          email: { email, required },
          password: { minLength: minLength(8), required },
          birthday: { minLength: minLength(10), required },
          cpf: { minLength: minLength(13), required },
          genderId: { required },
          telephone: { telephoneRule, required },
      }
    },
    data: () => ({
        firstCall:              true,
        validationTop:          false,
        termsDialog:            false,
        newContactObject: {
            birthday:           null,
            cpf:                null,
            email:              null,
            genderId:           null,
            name:               null,
            password:           null,
            telephone:          null,
            acebookAccessfToken: null,
             cidade: null,
            cidadenome: null,
        },
        estados: [],
        estado: null,
         search: null,
            cidades: [],
        loginInfo: {
            username: "",
            password: "",
            platform: 'cative',
            subdomain: ""
        },
        genders: [
            {name: 'Masculino', value: 1},
            {name: 'Feminino', value: 2}
        ],
        notCompleteRegistration:true,
        createBtnLoading:       false,
        ShowPassword:           false,
        showFacebookbtn:        true,
        missingInformation:     false,
        missingPassword:        false,
        userLastPoints:         null,
        signupByPontuation:     false,
        mobileVersion:          false

    }),
    created() {
        this.compareWidth()
        window.addEventListener("resize", this.compareWidth);
        this.setSignupUser()
          this.buscarCidades()
    },
    destroyed() {
        this.RESET_SIGNUP_USER()
        this.SET_ACCESS_SIGNUP(false)
    },
     watch: {
      search (val) {
        console.log('val:::', val)
        if(val) this.newContactObject.cidadenome = val;
      this.fetchEntriesDebounced()
    },  estado (val){
        if(val) {
            this.newContactObject.cidade = null;
            this.buscarCidades()
        } else this.newContactObject.cidade = null;
     }
     },
      mounted(){
       this.buscaEstados()
    },
    methods: {
        ...mapActions('authenticateStore', ['TO_LOG', 'FACEBOOK_SIGNUP']),
        ...mapActions('signupStore', ['RESET_SIGNUP_USER', 'SET_ACCESS_SIGNUP']),
        getSubdomain() {
            if (window.location.host.endsWith(".lity.com.br")) {
                this.loginInfo.subdomain = window.location.host.split(".")[0]
            } else {
                this.loginInfo.subdomain = window.location.host
            }
        },
         changeCidades(event, index) {
            console.log('event: ', {
                event, index
            })
        },
           buscarCidades(){            
              let searchFormatted = !this.search ? '' : this.search.toString().toUpperCase(); 
                    buscarCidadeIntegracao(this.estado, searchFormatted).then((response) => {
                    this.cidades = response.data;
                    console.log('ref: ', this.$refs.refCidades)
                }).catch((e) => {
                    console.log('error', e)
                })
         },
           buscaEstados(){
                buscarEstado().then((response) => {
                    this.estados = response.data;
                }).catch((e) => {
                    console.log('error', e)
                })
         },
         handleEstado(value){
            console.log('value: ', value)
        },
         fetchEntriesDebounced() {
            // cancel pending call
            clearTimeout(this._timerId)
                // delay new call 500ms
                this._timerId = setTimeout(() => {
                this.buscarCidades()
                }, 500)
            },
        compareWidth() {
            this.mobileVersion = ( window.innerWidth <= 960 )
        },
        getUserPoints( signUpTelephone ) {
            getLastPointByCompanyIdAndContactTelephone( this.currentCompany.id, signUpTelephone)
                .then( success => {
                        if( success.data.total ) {
                            this.userLastPoints = success.data.total
                        }
                    }
                )
                .catch( error => {
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        createAccount() {
            this.createBtnLoading = true
            if(this.notCompleteRegistration && this.signupUser.telephone) {
                this.newContactObject.telephone = this.signupUser.telephone
            }

            let inviteContactId = location.search.split("?i")[1];

            if (inviteContactId != null) {
                this.newContactObject.inviteContactId = parseInt(inviteContactId);
            }

            insertContactByCompanyId(this.currentCompany.id, this.newContactObject)
                .then( () => {
                        this.login()
                    }
                )
                .catch( error => {
                        this.createBtnLoading = false
                        if (error != null) {
                            if( error.message.startsWith('Já existe um cadastro com') ) {
                                this.redirectToLogin()
                            }
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        openTermsModal() {
            this.termsDialog = true
        },
        login() {
            this.getSubdomain()
            this.loginInfo.username = this.newContactObject.email
            this.loginInfo.password = this.newContactObject.password

            authenticate(this.loginInfo)
                .then( success => {
                            if( success.data ) {
                                this.TO_LOG(success.data)
                                this.notCompleteRegistration ? this.$router.push( {path: '/inicio'} ) : this.verifyNeedsRating()
                            }
                            this.createBtnLoading = false
                        }
                    )
                    .catch( error => {
                            if (error != null) {
                                this.$toasted.show(error.message == "Access Denied" ? " Usuário e/ou senha inválidos. " : error.message, { type: 'error' } )
                            }
                            this.createBtnLoading = false
                        }
                    )
        },
        verifyNeedsRating() {
            getPendingReviewsByCurrentContactIdAndCompanyId(this.currentCompany.id)
                .then( success => {
                        if(success.data.length < 1){
                            this.$router.push( {path: '/inicio'} )

                        } else {
                            this.$router.push( {path: `/avaliacao?id=${success.data[0].id}`} )
                        }
                    }
                )
                .catch( error => {
                        if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        setSignupUser() {
            if (location.search.split("?t")[1] != null) {
                this.notCompleteRegistration = false
                let hexTelephone = location.search.split("?t")[1];
                this.newContactObject.telephone = parseInt("0x" + hexTelephone).toString();
                this.getUserPoints( this.newContactObject.telephone )
                this.signupByPontuation = true
            } else {
                if (!this.haveAccessToSignup) {
                    let path = '/acessos'
                    let inviteContactId = location.search.split("?i")[1]

                    if (inviteContactId != null) {
                        path = path + "?i" + inviteContactId
                    }

                    this.$router.push( {path: path} )
                } else {
                  if(Object.keys(this.signupUser).length !== 0) {
                    this.newContactObject.birthday =this.signupUser.birthday ?  this.getDateByTimeStamp(this.signupUser.birthday) : null
                    this.newContactObject.name = this.signupUser.name
                    this.newContactObject.cpf = this.signupUser.cpf
                    this.newContactObject.genderId = this.signupUser.genderId
                    this.newContactObject.telephone =this.signupUser.telephone ? this.signupUser.telephone.replace('+55', '') : null
                    this.newContactObject.email = this.signupUser.email
                    this.newContactObject.cidade = this.signupUser.cidade
                    this.newContactObject.cidadenome = this.signupUser.cidadenome
                  }
                  this.notCompleteRegistration = true
                }
            }
        },
        changeCanProceed() {
            this.canProceed = this.validationTop
        },
        setUpperCaseName() {
            if( completeNameRule(this.newContactObject.name) ) {
                this.newContactObject.name = upperCaseCompleteName(this.newContactObject.name)
            }
        },
        facebookLogin() {
            this.FACEBOOK_SIGNUP()
                .then( success => {
                        this.verifyAndAttributeFacebookUserInfo(success)
                    }
                )
                .catch( error => {
                        console.log(error)
                        // Implementação futura de tratativa de erros
                    }
                )
        },
        verifyAndAttributeFacebookUserInfo( facebookUser ) {
            if( facebookUser ) {
                ( facebookUser.name && facebookUser.name != null )? this.newContactObject.name = facebookUser.name : this.missingInformation = true ;
                ( facebookUser.email && facebookUser.email != null )? this.newContactObject.email = facebookUser.email : this.missingInformation = true ;
                ( facebookUser.birthday && facebookUser.birthday != null )? this.newContactObject.birthday = facebookUser.birthday : this.missingInformation = true ;
                ( facebookUser.genderId && facebookUser.genderId != null )? this.newContactObject.genderId = facebookUser.genderId : this.missingInformation = true ;
                this.newContactObject.facebookAccessToken = facebookUser.accessToken
                
                if( !this.newContactObject.password ) this.missingPassword = true

                if( !this.missingInformation && !this.missingPassword ) this.createAccount()
                else {
                    this.showFacebookbtn = false
                }

            } else this.missingInformation = true
        },
        redirectToLogin() {
            this.$router.push( {path: '/login'} )
        },
        getDateByTimeStamp( data ){
          var moment = require('moment')
          var formatted =  moment(data).format("DD/MM/YYYY")
          return formatted;
        },
        submit() {
          this.$v.$touch()
          setTimeout(() => {
            if(this.validationTop) this.createAccount()
          }, 200);
        }
    }
}
</script>

<style scoped>

/*------------------- LOADING -------------------- */
::v-deep .custom-btn.theme--light.v-btn {
    color: var(--cor--branco);
}
.custom-btn{
    padding: 0px 0px 0px 2px !important;
    font-size: 13px;
}
/* @media(max-width: 623px){
    .col-form__signup {
        max-width: 600px !important;
    }
} */
.btn-subtitle{
    font-size: 13px !important;
}
.company-image--div{
    width: 90px;
    height: 90px;
    margin: 15px;
}
.company-image{
    border-radius: 25pc;
}
.company-name{
    font-weight: 800;
    font-size: 20px;
}
.right-panel{
    height: 100% !important;
    padding: 0px;
    margin: 0px;
}
@media (min-width: 623px) {
    .conditional-mg{
        margin-right: 0px;
    }    
    .conditional-pd{
        padding: 0px 30px !important;
    }
}
.conditional-mg{
    padding: 0px;
}
.container-align{
    align-items: start !important;
    height: 100%;
}
.validation-form{
    width: 100%;
    max-width: 600px !important;
}
.facebook-text{
    color: var(--cor--facebook);
    font-weight: 600;
    font-size: 14px;
}
.container-login__col_or{
    display: flex;
    flex: auto !important;
    color: var(--cor--cinza);
    justify-content: center;
    align-items: center;
    min-width: 300px;
    max-width: 660px;
    width: 100%
}
.lines{
    border: 0.5px solid var(--cor--cinza);
    width:40%;
    height: 1px;
}
.or{
    color: var(--cor--cinza);
    margin-left: 10px !important;
    margin-right: 10px !important;
    font-size: 20px;
    font-weight: 600;
}
.terms_margin{
    margin-right: 6px !important;
}
.h1--small {
    font-size: 28px !important;
    font-weight: 600 !important;
}
.h4--small {
    font-weight: 700 !important;
}

</style>
